var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('MainHeader'),(_vm.showPopup)?_c('Popup'):_vm._e(),_c('Availability'),_c('About'),_c('Accomodations'),_c('Attractions'),_c('Photos'),_c('Reviews'),_c('Contact'),_c('lazy-component',[_c('Location')],1),_c('lazy-component',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }